import { InventoryItemActionSource } from "@redotech/crdb-enums/inventory/inventory-item-action-source";
import { InventoryItemActionStatus } from "@redotech/crdb-enums/inventory/inventory-item-action-status";
import { InventoryRuleActionType } from "@redotech/crdb-enums/inventory/inventory-rule-action-type";
import { InventoryRuleRunType } from "@redotech/crdb-enums/inventory/inventory-rule-run-type";
import { inventoryRuleActionSchema } from "@redotech/redo-inventory-common/inventory-rules/rule-definition";
import {
  inventoryItemActionIdFormat,
  inventoryItemIdFormat,
  inventoryRuleIdFormat,
  inventoryRuleVersionIdFormat,
} from "@redotech/redo-inventory-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const ruleVersionRefSchema = z.object({
  ruleId: inventoryRuleIdFormat.schema,
  versionId: inventoryRuleVersionIdFormat.schema,
  version: z.int().positive(),
});

export const getInventoryItemLifecycle = unaryRpc({
  name: "getInventoryItemLifecycle" as const,
  input: z.object({
    inventoryItemId: inventoryItemIdFormat.schema,
    /** Also project the item's next scheduled steps from its current facts. */
    project: z.boolean().optional(),
  }),
  output: z.object({
    /** When the item's current stay in a bin began; null when it isn't in one. */
    inBinSince: z.date().nullable(),
    /** Oldest first, superseded decisions included. */
    actions: z.array(
      z.object({
        id: inventoryItemActionIdFormat.schema,
        actionType: z.enum(InventoryRuleActionType),
        status: z.enum(InventoryItemActionStatus),
        source: z.enum(InventoryItemActionSource),
        /** Null for a manual action. */
        rule: ruleVersionRefSchema.nullable(),
        runType: z.enum(InventoryRuleRunType).nullable(),
        runId: z.string().nullable(),
        details: z.record(z.string(), z.unknown()).nullable(),
        createdAt: z.date(),
        supersededAt: z.date().nullable(),
      }),
    ),
    /** Null unless `project` is set. Each step is checked again on the night it is due. */
    projection: z
      .array(
        ruleVersionRefSchema.extend({
          action: inventoryRuleActionSchema,
          dueAt: z.date(),
        }),
      )
      .nullable(),
  }),
});
